import { TableDataType } from "./eums"
import { TableColumnsInterface } from "./interfaces"

export enum enumCMSTypes {
  HOMEPAGE_BANNER = "HOMEPAGE_BANNER",
  BONUS_BANNER = "BONUS_BANNER",
  // PROMOTION_BANNER = "PROMOTION_BANNER",
  PROMOTIONS = "PROMOTIONS",
  TERMS_CONTENT = "TERMS_CONTENT",
  TENANT_COLORS = "TENANT_COLORS",
  TENANTS_CONFIG = "TENANTS_CONFIG"
}

export enum enumCMSTextTypes {
  TERMS_CONTENT = "TERMS_CONTENT",
  PRIVACY_POLICY_CONTENT = "PRIVACY_POLICY_CONTENT",
  RESPONSIBLE_GAMING_CONTENT = "RESPONSIBLE_GAMING_CONTENT",
  REFUND_POLICY_CONTENT = "REFUND_POLICY_CONTENT",
  KYC_POLICY_CONTENT = "KYC_POLICY_CONTENT",
  BETTING_RULES_CONTENT = "BETTING_RULES_CONTENT"
}

export const cmsTextTypeLabels: Record<enumCMSTextTypes, string> = {
  [enumCMSTextTypes.TERMS_CONTENT]: "Terms & Conditions",
  [enumCMSTextTypes.PRIVACY_POLICY_CONTENT]: "Privacy Policy",
  [enumCMSTextTypes.RESPONSIBLE_GAMING_CONTENT]: "Responsible Gaming",
  [enumCMSTextTypes.REFUND_POLICY_CONTENT]: "Refund Policy",
  [enumCMSTextTypes.KYC_POLICY_CONTENT]: "KYC Policy",
  [enumCMSTextTypes.BETTING_RULES_CONTENT]: "Betting Rules"
}

export const cmsTextTypeOptions = Object.values(enumCMSTextTypes).map((type) => ({
  name: cmsTextTypeLabels[type],
  value: type
}))

export const tableCMSColumns: TableColumnsInterface[] = [
  {
    value: "id",
    title: "Id",
    format: TableDataType.NUMBER,
    sorting: false,
    mntSorting: true
  },
  {
    value: "tenant_id",
    title: "Tenant",
    format: TableDataType.STRING,
    sorting: true
  },
  {
    value: "name",
    title: "Name",
    format: TableDataType.STRING,
    sorting: true
  },
  {
    value: "type",
    title: "Type",
    format: TableDataType.STRING,
    sorting: false,
    mntSorting: true
  },
  {
    value: "banner_image",
    title: "Desktop banner",
    format: TableDataType.IMAGE,
    sorting: false
  },
  {
    value: "banner_image_mobile",
    title: "Mobile banner",
    format: TableDataType.IMAGE,
    sorting: false
  },
  {
    value: "active",
    title: "Activated",
    format: TableDataType.BOOLEAN,
    sorting: true
  }
]
